import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { ROUTES } from '@/common/constants/routes';
import { useIsUpgradePeriodActive } from '@/common/integrations/menhir/employee/spotlights/spotlights.hooks';
import { safeLazy } from '@/common/utils/import';
import { Redirect } from 'expo-router';

const { InsuranceUpgradePlanPage } = safeLazy(
  () => import('@/web/containers/Insurance/Insurance')
);

export default function InsuranceUpgradePlanRootPage() {
  const isUpgradePeriodActive = useIsUpgradePeriodActive();

  if (!isUpgradePeriodActive) {
    return <Redirect href={ROUTES.INSURANCE} />;
  }

  return (
    <RouterSuspense>
      <InsuranceUpgradePlanPage />
    </RouterSuspense>
  );
}
